import { cn } from '@wellesley/ui'
import { ChevronDown } from 'lucide-react'
import { FC } from 'react'

type DropdownTitleProps = {
  title: string
  isOpen: boolean
}

export const DropdownTitle: FC<DropdownTitleProps> = ({ title, isOpen }) => {
  return (
    <div className="flex w-full cursor-pointer gap-xxxs overflow-hidden p-m pb-xs text-left">
      <h3 className="min-w-0 max-w-full truncate text-lg font-semibold text-gray-900">
        {title}
      </h3>
      <ChevronDown
        size={20}
        className={cn('mt-xxxs', {
          'rotate-180': isOpen,
        })}
      />
    </div>
  )
}
